export const props = Object.freeze({
  /**
   * Separator glyph between adjacent items. Note that the current implementation renders ">" via a ::slotted ::after rule — this prop is reserved for a future configurable separator pass.
   *
   * @type {String}
   * @default "/"
   */
  separator: {
    type: String,
    default: "/",
  },
});
